import { clientApi } from '../../configuration';
import { getPermissionListHook } from '../../utils';

type TeamsPermissionCodes =
  | 'ACCESS_TEAM_ANALYTICS'
  | 'REMOVE_TEAM_USER'
  | 'EDIT_TEAM'
  | 'EDIT_TEAM_USER_ROLES'
  | 'SEND_TEAM_INVITATION'
  | 'SHOW_TEAM'
  | 'GET_TEAM_USER'
  | 'GET_TEAM_USERS'
  | 'DELETE_TEAM'
  | 'DELETE_INVITATIONS'
  | 'GET_PLAYLIST'
  | 'CREATE_PLAYLIST'
  | 'EDIT_PLAYLIST'
  | 'DELETE_PLAYLIST';

const useTeamsPermissions = getPermissionListHook<TeamsPermissionCodes, 'teams'>({
  entityName: 'teamsPermissions',
  apiResponseRootKey: 'teams',
  fetch: () => clientApi.getOCClient().helpers.user.me.getTeamsPermissions(),
});

export default useTeamsPermissions;
